import React from 'react';
import Lines from './Lines';

const Summary = ({ summary }) => {
    return (
        <section className="section summary">
            {
                summary.map((line, i) => {
                    let el;

                    if (Array.isArray(line)) {
                        el = <Lines line={ line } isList />;
                    }
                    else {
                        el = (<p key={ `line-${ i }` }>{ line }</p>);
                    }

                    return el;
                })
            }
        </section>
    )
};

export default Summary;
